import { createFeatureSelector, createSelector } from "@ngrx/store";
import { featurekey, HamptonValuationState } from "../_reducers/hampton-valuation.reducer";

const selectFeatureState = createFeatureSelector<HamptonValuationState>(featurekey)

export const selectComparableOverview = createSelector(
  selectFeatureState,
  state => {
    return state.comparableOverview
  }
)

export const selectComparableAnalysis = createSelector(
  selectFeatureState,
  state => {
    return state.comparableAnalysis
  }
)

export const selectHamptonAnalysis = createSelector(
  selectFeatureState,
  state => {
    return state
  }
)

export const selectHamptonAnalysisValid = createSelector(
  selectFeatureState,
  state => {
    if (state.comparablesPriceLowerEnd === null) return false;
    if (state.comparablesPriceHigherEnd === null) return false;
    if (state.consultantLower === null) return false;
    if (state.consultantHigher === null) return false;
    if (state.valuerLower === null) return false;
    if (state.valuerHigher === null) return false;
    if (state.reasoning === null) return false;
    if (state.valueRangeId === null) return false;
    if (state.valueEstimated === null) return false;
    if (state.rentalValueLower === null) return false;
    if (state.rentalValueHigher === null) return false;
    return true
  }
)

export const selectIsHamptonModule = createSelector(
  selectFeatureState,
  state => {
    if (state.comparableAnalysis === 'qualitative') return true;
    return false;
  }
)